import { t } from '@lingui/macro';
import { Alert } from '@pocketlaw/tetris';
export function OverrideAlert() {
    return (<Alert appearance="info" message={t({
            message: 'You are editing multiple templates with different attachments',
            comment: 'Info message for editing default attachments for multiple templates with different attachments',
        })}/>);
}
